import {
  ChangeDetectorRef, Component, OnInit,
} from '@angular/core';
import { HttpResponse } from '../../../application/types/HttpResponse';
import { ChampionshipApiService } from '../../services/championship-api/ChampionshipApiService';
import { Championship } from '../../types/Event';
import { resolveTeamLogoBackground } from '../../utils/resolveTeamLogoUrl';

@Component({
  selector: 'app-championship-directory-page',
  standalone: false,
  templateUrl: './championship-directory-page.component.html',
  styleUrl: '../team-directory-page/team-directory-page.component.sass',
})
export class ChampionshipDirectoryPageComponent implements OnInit {
  public championships: Championship[] = [];
  public sortDirection: 'asc' | 'desc' = 'asc';
  public loading = false;
  public errorMessage: string | null = null;

  public constructor(
    private championshipApi: ChampionshipApiService,
    private changeDetector: ChangeDetectorRef,
  ) { }

  public async ngOnInit(): Promise<void> {
    this.loading = true;
    try {
      const response = await this.championshipApi.getChampionships();
      const championships = this.unwrapResponse(response);
      this.championships = championships ?? [];
    } catch (error) {
      this.errorMessage = error instanceof Error ? error.message : 'Не удалось загрузить чемпионаты.';
    } finally {
      this.loading = false;
      this.changeDetector.detectChanges();
    }
  }

  public get sortedChampionships(): Championship[] {
    const factor = this.sortDirection === 'asc' ? 1 : -1;
    return [
      ...this.championships,
    ].sort((left, right) => left.name.localeCompare(right.name, 'ru') * factor);
  }

  public toggleSort(): void {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

  public getLogoBackground(championship: Championship): string | null {
    return resolveTeamLogoBackground(championship.logoUrl);
  }

  public trackById(_index: number, item: { id: string }): string {
    return item.id;
  }

  private unwrapResponse<ResponseType>(response: HttpResponse<ResponseType>): ResponseType | null {
    if (response.status === 'failed') {
      this.errorMessage = response.errorMessage;
      return null;
    }

    return response.response;
  }
}
